import { z } from 'zod';
/**
 * Populated Role Schema
 *
 * The minimal `{ _id, name }` display projection of a user's role — i.e. their
 * mainRole, which is a role-kind OrgFunction. Surfaced where only the role's name
 * is shown (system statistics: critical-dependency assignees, top roles by user
 * count). The full record and membership live on the OrgFunction entity; this is a
 * read-only display shape, never written.
 */ export const PopulatedRoleSchema = z.object({
    _id: z.string(),
    name: z.string()
});

//# sourceMappingURL=role.schema.js.map